export const SECOND = 1000;
export const MINUTE = SECOND * 60;
export const HOUR = MINUTE * 60;
export const DAY = HOUR * 24;
export const WEEK = DAY * 7;
export const MONTHS_INDEXED = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
